import { PublicPageShell, Section } from "../components/PublicPageShell";

export default function Disclaimer() {
  return (
    <PublicPageShell overline="Important information" title="Disclaimer" updated="February 2026" testId="disclaimer-page">
      <Section heading="What SphereInvest AI is — and is not">
        <p>
          SphereInvest AI is an investment research and analytical technology platform. It does not execute trades,
          hold client funds or provide personalised financial advice. Information provided through the platform is for
          research and educational purposes only. Capital at risk: the value of investments can fall as well as rise.
        </p>
        <p>
          Everything you see here — screens, indicators, AI summaries, simulations — is research insight designed to
          support, not replace, your own decisions. If you are unsure whether an investment is right for you, consult
          a regulated financial adviser.
        </p>
      </Section>

      <Section heading="No FCA authorisation">
        <p>
          SphereInvest AI is not authorised or regulated by the Financial Conduct Authority, and nothing on the
          platform should be read as implying otherwise. The platform does not carry on regulated activities such as
          advising on investments, managing investments or arranging deals.
        </p>
      </Section>

      <Section heading="AI limitations">
        <ul className="list-disc pl-5 space-y-2">
          <li>AI models can be wrong, out of date or miss context. Outputs are probabilistic text, not verified facts.</li>
          <li>AI summaries are grounded in our cached data — but the model can still misread it. Always verify the underlying numbers before acting.</li>
          <li>Nothing the AI writes is a prediction, price target or instruction, and it must never be treated as one.</li>
        </ul>
      </Section>

      <Section heading="Data limitations">
        <ul className="list-disc pl-5 space-y-2">
          <li>Market data comes from Yahoo Finance, is typically delayed or end-of-day, and is cached up to 12 hours — it is not suitable for timing trades.</li>
          <li>Coverage is a fixed universe of ~73 US &amp; UK large caps; the platform cannot see other companies.</li>
          <li>Third-party data may contain errors or gaps beyond our control. See the <a href="/methodology" className="text-primary hover:underline">methodology page</a> for full details.</li>
        </ul>
      </Section>

      <Section heading="Past performance">
        <p>
          Past performance is not a reliable indicator of future results. Simulator projections are mathematical
          illustrations based on your inputs, not forecasts of what will happen.
        </p>
      </Section>
    </PublicPageShell>
  );
}
